var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "22px",
    viewBox: "0 0 12 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ACAF9A9D-F959-4453-8A96-698DF63F3F06") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Provider-Calendar",
    transform: "translate(-60.000000, -187.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(66.000000, 198.500000) scale(-1, 1) translate(-66.000000, -198.500000) translate(50.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "angle-arrow-down",
    transform: "translate(16.000000, 19.000000) rotate(-90.000000) translate(-16.000000, -19.000000) translate(5.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7801768,1.2370114 L20.6780496,0.206252821 C20.531192,0.0686065056 20.36202,0 20.1707653,0 C19.979974,0 19.8108792,0.0686065056 19.6640216,0.206252821 L11.0001158,8.30925887 L2.33659613,0.206469473 C2.18966128,0.0688231577 2.02056653,0.000216652123 1.8295435,0.000216652123 C1.63844326,0.000216652123 1.4693485,0.0688231577 1.32249087,0.206469473 L0.220518094,1.23730027 C0.0733516069,1.37465772 0,1.53281377 0,1.71155177 C0,1.89014534 0.0735832435,2.04830139 0.220518094,2.18565883 L10.4930632,11.7938916 C10.6399208,11.9313213 10.8090928,12 11.0001158,12 C11.1911388,12 11.360002,11.9313213 11.5067824,11.7938916 L21.7801768,2.18565883 C21.9270345,2.04822917 22,1.89007312 22,1.71155177 C22,1.53281377 21.9270345,1.37465772 21.7801768,1.2370114 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.48d84570eb8a926db4fce3b1260901b3.svg";
export { ForwardRef as ReactComponent };